/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whitespace Cleaner — Trim & Remove Extra Spaces | Toolverse`)
};

const es_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiador de Espacios en Blanco — Recorta y Elimina Espacios Extras | Toolverse`)
};

const de_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerzeichen-Bereiniger — Trimmen & überflüssige Leerzeichen entfernen | Toolverse`)
};

const nl_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witruimte Opruimer — Trim & Verwijder Extra Spaties | Toolverse`)
};

const fr_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyeur d'espaces blancs — Supprimer les espaces supplémentaires | Toolverse`)
};

const it_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulitore di Spazi Bianchi — Taglia e Rimuovi gli Spazi Extra | Toolverse`)
};

const pt_br2_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de Espaços em Branco — Aparar e Remover Espaços Extras | Toolverse`)
};

const pt_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de Espaços em Branco — Apare e Remova Espaços Extras | Toolverse`)
};

const ja_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホワイトスペースクリーナー — トリムと余分なスペース削除 | Toolverse`)
};

const zh_wsc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白字符清理工具 — 修剪并删除多余空格 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_meta_title", locale)
	if (locale === "en") return en_wsc_meta_title(inputs)
	if (locale === "es") return es_wsc_meta_title(inputs)
	if (locale === "de") return de_wsc_meta_title(inputs)
	if (locale === "nl") return nl_wsc_meta_title(inputs)
	if (locale === "fr") return fr_wsc_meta_title(inputs)
	if (locale === "it") return it_wsc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_meta_title(inputs)
	if (locale === "pt") return pt_wsc_meta_title(inputs)
	if (locale === "ja") return ja_wsc_meta_title(inputs)
	return zh_wsc_meta_title(inputs)
};